import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var attendanceUserListRes;
export const attendanceUserListTodo = createAsyncThunk('attendanceUserList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/get_attendence_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "training_id": val,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return attendanceUserListRes = res.data
    } catch (error) {
        return attendanceUserListRes = error.response.data
    }
})


const attendanceUserListSlice = createSlice({
    name: 'attendanceUserList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(attendanceUserListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('attendanceUserList', state.data)
            }
        });
        builder.addCase(attendanceUserListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default attendanceUserListSlice.reducer; 